import { onClickOutside, onEscape } from './dismiss.js';

export function initLangSwitcher() {
  const root = document.querySelector('[data-lang-switcher]');
  const toggle = root?.querySelector('[data-lang-toggle]');
  const menu = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
  if (!menu) return;

  const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
  const setOpen = (open) => {
    menu.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  };

  toggle.addEventListener('click', () => setOpen(!isOpen()));
  onClickOutside(root, () => setOpen(false));
  onEscape(() => {
    if (!isOpen()) return;
    setOpen(false);
    toggle.focus();
  });
}
